import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { motion } from "framer-motion";
import { eur } from "../lib/api";
import { useCart } from "../context/CartContext";

export default function ProductCard({ product, className = "", index = 0 }) {
  const { addItem } = useCart();
  const soldOut = (product.stock ?? 1) <= 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay: (index % 3) * 0.12, ease: [0.16, 1, 0.3, 1] }}
      className={`group relative spotlight-card ${className}`}
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/prodotto/${product.id}`} className="block h-full" data-testid={`product-link-${product.id}`}>
        <div className="relative h-full overflow-hidden border border-white/10 group-hover:border-primary/40 transition-colors duration-500">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 flex items-end justify-between gap-4">
            <div>
              <p className="text-[10px] uppercase tracking-[0.3em] text-primary mb-2">
                {product.category}
              </p>
              <h3 className="font-serif text-2xl md:text-3xl font-light leading-tight">
                {product.name}
              </h3>
              <p className="text-sm text-white/70 mt-2 tracking-wide">{eur(product.price)}</p>
              {soldOut && (
                <p className="text-[10px] uppercase tracking-[0.3em] text-destructive mt-2" data-testid={`soldout-${product.id}`}>
                  Esaurito
                </p>
              )}
            </div>
            {!soldOut && (
            <button
              data-testid={`quick-add-${product.id}`}
              onClick={(e) => {
                e.preventDefault();
                addItem(product, 1);
              }}
              className="h-11 w-11 flex-shrink-0 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors duration-300 md:opacity-0 md:group-hover:opacity-100"
              aria-label={`Aggiungi ${product.name} al carrello`}
            >
              <Plus size={17} strokeWidth={1.5} />
            </button>
            )}
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
